import React, { Component } from 'react';
import '../styles/Main.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

class Main extends Component {
  render() {
    return (
      <div className="Main">
        <div className="title-bg">
          <div className="title-overlay">
          </div>
          <div className="container">
            <div className="title-text text-center row align-items-center">
              <div className="col">
                <h1>Mainline Crafts, Inc</h1>
                <hr />
                <FontAwesomeIcon 
                  icon="phone"
                  color="#FFFFFF"
                  size="sm" 
                />
                <p className="">847-419-1332</p>
                <FontAwesomeIcon 
                  icon="building"
                  color="#FFFFFF"
                  size="sm" 
                />
                <p className="">275 12th Street B <br /> Wheeling, IL 60090</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/Main.js